import { ROUTES } from '../../constants/routes';

/**
 * Path the phone-handoff QR encodes.
 *
 * `mode=photo` opens the capture screen's source picker and `intent=equipment`
 * makes the review sheet default to Equipment instead of Photo note. `ws`
 * activates the same workspace the desktop user is in (a Prisma UUID, not a
 * secret — membership is still validated server-side on switch). Deliberately
 * credential-free: see the docblock on MobileAccessQR for why this is not a
 * magic link.
 *
 * Lives in its own module, not beside the modal: it is a pure string builder,
 * and importing the modal to reach it drags in the Firebase-initialising
 * service chain, which throws at import time wherever no API key is configured.
 */
export function buildEquipmentCapturePath(workspaceId: string | null | undefined): string {
  const params = new URLSearchParams({ mode: 'photo', intent: 'equipment', src: 'equipment_qr' });
  if (workspaceId) params.set('ws', workspaceId);
  return `${ROUTES.mobileCapture}?${params.toString()}`;
}
